// extracted by mini-css-extract-plugin
var _1 = "wrapper__Iqbfa";
export { _1 as "wrapper" }
